/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useNotificationProvider } from 'hooks';
import { CANtrackComment } from '../types/comment';
import getComments from 'api/comments/getComments';
import { convertToCANtrackComment } from '../utils/convertToCANtrackComment';

interface CommentFilter {
	employeeId: string;
	date: Date;
	take?: number;
	page?: number;
}
const useComments = () => {
	const [comments, setComments] = useState<CANtrackComment[]>([]);
	const [loadingComments, setLoadingComments] = useState<boolean>(false);
	const { notifyError, notifySuccess } = useNotificationProvider();

	const fetchComments = async (filter: CommentFilter) => {
		try {
			setLoadingComments(true);
			console.log('filter', filter);
			const data = await getComments(filter.date, filter.employeeId);

			const convertedData: CANtrackComment[] = data.map((entry) => {
				return convertToCANtrackComment(entry);
			});
			setComments(convertedData);
		} catch (e) {
			console.log('Failed to fetch comments', e);
			notifyError('Failed to fetch timesheetEntries');
		} finally {
			setLoadingComments(false);
		}
	};

	return {
		comments,
		loadingComments,
		setComments,
		fetchComments,
	};
};

export default useComments;
